import { ATTEMPT_STORAGE_KEY_PREFIX } from "./paymentPage.constants";

const DECIMAL_RADIX = 10;

export const NO_STORED_ATTEMPT = Object.freeze({ isStored: false });

function buildAttemptStorageKey(paymentLinkId) {
    return ATTEMPT_STORAGE_KEY_PREFIX + paymentLinkId;
}

export function writeStoredAttempt(paymentLinkId, attemptId) {
    window.sessionStorage.setItem(buildAttemptStorageKey(paymentLinkId), String(attemptId));
}

export function readStoredAttempt(paymentLinkId) {
    const storedAttemptId = window.sessionStorage.getItem(buildAttemptStorageKey(paymentLinkId));
    if (storedAttemptId === null) {
        return NO_STORED_ATTEMPT;
    }
    return Object.freeze({ isStored: true, attemptId: Number.parseInt(storedAttemptId, DECIMAL_RADIX) });
}
